import React from 'react'
import Container from 'react-bootstrap/esm/Container'
import { TbBorderRadius } from 'react-icons/tb'

export const Teacher = () => {
  return (
    <div><img style={{height : "100px", width : "100px", marginRight :"1200px", float :"left"}} src="/images/1696169183924web_dev_1.jpg" alt="" srcset="" />
    <div  className='h1'  ></div>
    Dr megha rana 
    
    
        <h3 style={{color : "green" , marginRight : "170px"}}>qualification </h3>
        
        <img style={{borderradius : "50%" , marginTop : "75px", padding  : "5px", marginTop : "50px"}} src="client/public/images/1696169592845web_dev_5.jpg" alt="" srcset="" />
       
        <h5 style={{ fontSize : "20px" ,color :"Blue", margin : "Left"}}>About Me</h5>
        <div className="userface">
       

       <p style={{fontSize: "20px"}}>I'm Angela, I'm a developer with a passion for teaching. I'm the lead instructor at the London App Brewery, London's leading Programming Bootcamp. I've helped hundreds of thousands of students learn to code and change their lives by becoming a developer. I've been invited by companies such as Twitter, Facebook and Google to teach their employees.Experience in teaching, whether in a formal educational setting, as a mentor, or through online platforms, is valuable. It helps if the teacher understands how to effectively communicate complex concepts and guide students through the learning process.</p>
    </div>
               
    </div>
  )
}
